import React from 'react';
import BusComponent from '../../../components/BusComponent';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import DealListDropdown from './DealListDropdown';
import NoDealsInListPage from './NoDealsInListPage';
import ConfirmationPopup from '../ConfirmationPopup';
import {SELFSTORAGE_POINT_TYPE} from "../../../enums/SelfStoragePointType";
import LocationAnalysisType from '../../../enums/LocationAnalysisType';

class DealsFromSelectedListPanel extends BusComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            deals: [],
        };

        this.bindGluBusEvents({
            VISUAL_REPORTS_FROM_ACTIVE_LIST: this.onVisualReportsFromActiveList,
            VISUAL_REPORT_DELETE_SUCCESS: this.onVisualReportDeleteSuccess,
        });
    }

    componentDidMount() {
        this.emit('VISUAL_REPORTS_FROM_ACTIVE_LIST_GET_REQUEST');
    }

    componentWillUnmount() {
        this.unbindGluBusEvents();
    }

    onVisualReportsFromActiveList = ({ visualReports }) => {
        this.setState({ deals: visualReports });
    };

    onVisualReportDeleteSuccess = () => {
        this.emit('VISUAL_REPORTS_FROM_ACTIVE_LIST_GET_REQUEST');
        this.emit('DEAL_LISTS_LOAD_REQUEST');
    };

    onDeleteDealClicked = (e, deal) => {
        e.stopPropagation();
        this.emit('OPEN_MODAL', {
            modalContent: (
                <ConfirmationPopup
                    confirmLabel={this.props.intl.formatMessage({ id: 'delete' })}
                    onConfirm={() => this.emit('VISUAL_REPORT_DELETE_REQUEST', deal.id)}
                >
                    {this.props.intl.formatMessage({ id: 'areYouSureYouWantToDelete' })}
                    <h5> {deal.title}? </h5>
                </ConfirmationPopup>
            ),
            name: 'Delete deal confirmation',
            title: 'modals.deleteDeal',
            modalBoxClass: 'modal-box--confirmation',
            canClickAway: true,
            hideCloseButton: true,
        });
    };

    onDealSelected = deal => {
        const { mapInstance } = this.props;

        this.bus.emit('START_LOCATION_ANALYSIS', {
            visualReport: deal,
            mapInstanceId: mapInstance.id,
        });
    };

    getIconForPointType = type => {
        switch (type) {
            case SELFSTORAGE_POINT_TYPE.SS_FACILITY:
                return 'warehouse';
            case SELFSTORAGE_POINT_TYPE.SS_CONSTRUCTION:
                return 'foundation';
            default:
                return 'place';
        }
    };

    getAnalysisInfo = deal => {
        if (deal.profile === 'polygon') return LocationAnalysisType.POLYGON.NAME;
        const selectionValue = deal.selection[deal.selection.length - 1];
        const analysisValueLabel =
            deal.profile === 'radius'
                ? selectionValue === 1
                    ? selectionValue + ' mile'
                    : selectionValue + ' miles'
                : selectionValue === 1
                  ? selectionValue + ' min'
                  : selectionValue + ' mins';

        return deal.address && deal.address.label
            ? analysisValueLabel + ' around ' + deal.address.label
            : analysisValueLabel;
    };

    render() {
        const { onBack, onClose, mapInstance } = this.props;
        const { deals } = this.state;

        const dealsCountLabel = deals && deals.length > 1 ? deals.length + ' deals' : '1 deal';

        return (
            <div className="deal-list-panel">
                <div className="panel-header">
                    <div className="panel-header__back-container" onClick={onBack}>
                        <button onClick={onBack}>
                            <i className="material-icons-outlined">arrow_back</i>
                        </button>
                    </div>

                    <div className="panel-header__dropdown-container">
                        <DealListDropdown
                            mapInstance={mapInstance}
                            isVisible={true}
                            hideVisibilityToggle={true}
                        />
                    </div>

                    <div className="panel-header__close-container" onClick={onClose}>
                        <button onClick={onBack}>
                            <i className="material-icons-outlined">close</i>
                        </button>
                    </div>
                </div>

                <div className="map-layers-panel__popup__horizontal-divider" />

                <div className="panel-content">
                    {deals && deals.length ? (
                        <span className="panel-content__header">{dealsCountLabel}</span>
                    ) : (
                        <NoDealsInListPage />
                    )}
                    {deals.map(deal => {
                        return (
                            <div
                                className="panel-content__item-container"
                                key={deal.id}
                                onClick={() => this.onDealSelected(deal)}
                            >
                                <div className="panel-content__item truncate">
                                    <i className="material-symbols-outlined">
                                        {this.getIconForPointType(deal.pointType)}
                                    </i>
                                    <div className="deal-name-container truncate">
                                        <span className="deal-title truncate" title={deal.title}>
                                            {deal.title}
                                        </span>
                                        <span
                                            className="deal-analysis truncate"
                                            title={
                                                deal.address && deal.address.label
                                                    ? deal.address.label
                                                    : ''
                                            }
                                        >
                                            {this.getAnalysisInfo(deal)}
                                        </span>
                                    </div>
                                </div>
                                <button
                                    className="panel-content__delete-btn"
                                    onClick={e => this.onDeleteDealClicked(e, deal)}
                                    title="Delete deal"
                                >
                                    <i className="material-symbols-outlined">delete</i>
                                </button>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

DealsFromSelectedListPanel.propTypes = {
    mapInstance: PropTypes.object.isRequired,
    onBack: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
};

export default injectIntl(DealsFromSelectedListPanel);
